import { StaffColumns } from 'components/Table/Columns/StaffColumns';
import { TableBody } from 'components/Table/TableBody/TableBody';
import { TableConfig } from 'models/general';
import { getStaff } from 'services/user';
import { queryKeys } from 'utils/query';
import { Staff } from 'utils/models';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';

const staffListConfig: TableConfig = {
  queryKey: queryKeys.staff,
};

export const StaffList = () => {
  return (
    <TableBody<Staff>
      getData={getStaff}
      getColumns={StaffColumns}
      config={staffListConfig}
      titleBar={<PaperHeader titleKey={'group_staff_title'} iconKey={'groupsettings_general_staff_tooltip'} />}
    />
  );
};
